import { useEntityPreview } from '@/contexts/EntityPreviewContext';

/**
 * RefLink — klikatelný badge na referencovanou entitu (UX vrstva B).
 * Otevírá globální preview modal.
 *
 * Použití: <RefLink type="order" id={cal.orderNumber} />
 *          <RefLink type="intake" id={cal.intakeProtocolNumber} />
 */
export default function RefLink({ type, id, label, className = '' }) {
  const { openOrder, openIntake } = useEntityPreview();
  if (!id) return null;
  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (type === 'order') openOrder(id);
    else if (type === 'intake') openIntake(id);
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      className={`text-xs px-1.5 py-0.5 rounded font-mono transition-all hover:brightness-110 cursor-pointer ${className}`}
      style={{
        background: 'rgba(var(--ct-accent-rgb), 0.1)',
        color: 'var(--ct-accent)',
        border: '1px solid rgba(var(--ct-accent-rgb), 0.25)',
      }}
      title={`Zobrazit detail (${type === 'order' ? 'objednávka' : 'příjem'})`}
    >
      {label || id}
    </button>
  );
}
